!function () {
  "use strict";

  function r(r) {
    for (var t = [], e = 0; e < r.length; e++) {
      t.push(r[e]);
    }

    return t;
  }

  String.prototype.codePointAt || !function () {
    var r = function () {
      try {
        var r = {},
            t = Object.defineProperty,
            e = t(r, r, r) && t;
      } catch (r) {}

      return e;
    }(),
        t = function t(r) {
      if (null == this) throw TypeError();
      var t = this + "",
          e = t.length,
          n = r ? +r : 0;

      if (n != n && (n = 0), !(n < 0 || n >= e)) {
        var o,
            i = t.charCodeAt(n);
        return i >= 55296 && i <= 56319 && e > n + 1 && (o = t.charCodeAt(n + 1), o >= 56320 && o <= 57343) ? 1024 * (i - 55296) + o - 56320 + 65536 : i;
      }
    };

    r ? r(String.prototype, "codePointAt", {
      value: t,
      configurable: !0,
      writable: !0
    }) : String.prototype.codePointAt = t;
  }(), String.prototype.repeat || !function () {
    var r = function () {
      try {
        var r = {},
            t = Object.defineProperty,
            e = t(r, r, r) && t;
      } catch (r) {}

      return e;
    }(),
        t = function t(r) {
      if (null == this) throw TypeError();
      var t = this + "",
          e = r ? +r : 0;
      if (e != e && (e = 0), e < 0 || e == 1 / 0) throw RangeError();

      for (var n = ""; e;) {
        e % 2 == 1 && (n += t), e > 1 && (t += t), e >>= 1;
      }

      return n;
    };

    r ? r(String.prototype, "repeat", {
      value: t,
      configurable: !0,
      writable: !0
    }) : String.prototype.repeat = t;
  }(), String.prototype.includes || !function () {
    var r = {}.toString,
        t = function () {
      try {
        var r = {},
            t = Object.defineProperty,
            e = t(r, r, r) && t;
      } catch (r) {}

      return e;
    }(),
        e = "".indexOf,
        n = function n(t) {
      if (null == this) throw TypeError();
      var n = this + "";
      if (t && "[object RegExp]" == r.call(t)) throw TypeError();
      var o = n.length,
          i = t + "",
          a = i.length,
          c = arguments.length > 1 ? arguments[1] : void 0,
          u = c ? +c : 0;
      return u != u && (u = 0), !(a + Math.min(Math.max(u, 0), o) > o) && e.call(n, i, u) != -1;
    };

    t ? t(String.prototype, "includes", {
      value: n,
      configurable: !0,
      writable: !0
    }) : String.prototype.includes = n;
  }(), String.prototype.startsWith || !function () {
    var r = function () {
      try {
        var r = {},
            t = Object.defineProperty,
            e = t(r, r, r) && t;
      } catch (r) {}

      return e;
    }(),
        t = {}.toString,
        e = function e(r) {
      if (null == this) throw TypeError();
      var e = this + "";
      if (r && "[object RegExp]" == t.call(r)) throw TypeError();
      var n = e.length,
          o = r + "",
          i = o.length,
          a = arguments.length > 1 ? arguments[1] : void 0,
          c = a ? +a : 0;
      c != c && (c = 0);
      var u = Math.min(Math.max(c, 0), n);
      if (i + u > n) return !1;

      for (var l = -1; ++l < i;) {
        if (e.charCodeAt(u + l) != o.charCodeAt(l)) return !1;
      }

      return !0;
    };

    r ? r(String.prototype, "startsWith", {
      value: e,
      configurable: !0,
      writable: !0
    }) : String.prototype.startsWith = e;
  }(), String.prototype.endsWith || !function () {
    var r = function () {
      try {
        var r = {},
            t = Object.defineProperty,
            e = t(r, r, r) && t;
      } catch (r) {}

      return e;
    }(),
        t = {}.toString,
        e = function e(r) {
      if (null == this) throw TypeError();
      var e = this + "";
      if (r && "[object RegExp]" == t.call(r)) throw TypeError();
      var n = e.length,
          o = r + "",
          i = o.length,
          a = n;

      if (arguments.length > 1) {
        var c = arguments[1];
        void 0 !== c && (a = c ? +c : 0, a != a && (a = 0));
      }

      var u = Math.min(Math.max(a, 0), n),
          l = u - i;
      if (l < 0) return !1;

      for (var h = -1; ++h < i;) {
        if (e.charCodeAt(l + h) != o.charCodeAt(h)) return !1;
      }

      return !0;
    };

    r ? r(String.prototype, "endsWith", {
      value: e,
      configurable: !0,
      writable: !0
    }) : String.prototype.endsWith = e;
  }(), String.fromCodePoint || !function () {
    var r = function () {
      try {
        var r = {},
            t = Object.defineProperty,
            e = t(r, r, r) && t;
      } catch (r) {}

      return e;
    }(),
        t = String.fromCharCode,
        e = Math.floor,
        n = function n(r) {
      var n,
          o,
          i = 16384,
          a = [],
          c = -1,
          u = arguments.length;
      if (!u) return "";

      for (var l = ""; ++c < u;) {
        var h = +arguments[c];
        if (!isFinite(h) || h < 0 || h > 1114111 || e(h) != h) throw RangeError("Invalid code point: " + h);
        h <= 65535 ? a.push(h) : (h -= 65536, n = (h >> 10) + 55296, o = h % 1024 + 56320, a.push(n, o)), (c + 1 == u || a.length > i) && (l += t.apply(null, a), a.length = 0);
      }

      return l;
    };

    r ? r(String, "fromCodePoint", {
      value: n,
      configurable: !0,
      writable: !0
    }) : String.fromCodePoint = n;
  }(), Object.defineProperty(String, "raw", {
    configurable: !0,
    enumerable: !1,
    writable: !0,
    value: function value(t, e) {
      var n;
      t = null != t ? t : {}, e = arguments.length > 1 ? r(arguments).slice(1) : [];

      try {
        n = r(t.raw);
      } catch (r) {
        throw new TypeError("Cannot convert undefined or null to object");
      }

      return n.map(function (r, n) {
        return t.raw.length <= n ? r : null != e[n - 1] ? e[n - 1] + r : r;
      }).join("");
    }
  });
}();